export function formatDuration(minutes) {
    const numericMinutes = Number(minutes);

    if (!Number.isFinite(numericMinutes) || numericMinutes <= 0) {
        return "0 min";
    }

    const totalMinutes = Math.round(numericMinutes);
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    if (hours > 0 && remainingMinutes > 0) {
        return `${hours} h ${remainingMinutes} min`;
    }

    if (hours > 0) {
        return `${hours} h`;
    }

    return `${remainingMinutes} min`;
}
